module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dropdown', {
    attrs: {
      "split-button": "",
      "size": "mini",
      "type": "info",
      "trigger": "click"
    },
    on: {
      "command": _vm.handleCommand
    }
  }, [(this.value) ? _c('strong', [_vm._v(_vm._s(_vm.selectedIndex))]) : _c('strong', [_vm._v("?")]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, _vm._l((_vm.canvasQuestions), function(question, index) {
    return _c('el-dropdown-item', {
      key: index,
      attrs: {
        "command": question,
        "disabled": _vm.excludeQuestions.includes(question.id)
      }
    }, [_c('strong', [_vm._v(_vm._s(index + 2) + ".")]), _vm._v("\n      " + _vm._s(question.title) + "\n    ")])
  }), 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e776809a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/surveybuilder/editors/ConditionalLinkSelect.vue
// module id = 3412
// module chunks = 3